import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.updateUser.loading;
export const scheduleFilterErrorMessage = (state: RootState) =>
  state.scheduleFilter.error;
export const scheduleFilterResponse = (state: RootState) =>
  state.scheduleFilter.scheduleFilterResponse;
